import { AxiosInstance } from 'axios';
import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import {
  AppealApplicationRecordsResponse,
  AppealAvailableLevelResponse,
  AppealDraftRequestBody,
  AppealDraftResponseBody,
  AppealFeeResponse,
  AppealListingResponse,
  AppealProceedToPaymentRequestBody,
  AppealProceedToPaymentResponseBody,
  AppealSummaryResponse,
  AppealTransactionDetailsInSummary,
  EligibilityResponse,
  ExamLevelCodeRequest,
} from '../../model';
import { ResitDownloadSummary } from '../../../../../models/@candidate/candidateResitRegistrationSchema';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/appeal`;
const timeout = 10000;

export const appealClient = axiosFactory(baseURL, timeout);
export const appealCandidateClient = axiosFactory(baseURL, timeout);

export const appealTestCandidateClient = (appealClient as unknown) as AxiosInstance;

/** to get appeal exam level fees
 * */
export const getAppealFees = () => appealClient.get<AppealFeeResponse>(`${ROUTES.GET_APPEAL_FEES}`);

/** to get appeal exam level fees
 * */
export const getAppealApplicationRecords = (appealUuid?: string) => {
  let route = ROUTES.GET_APPEAL_APPLICATION_RECORDS;
  if (appealUuid) {
    route += `?uuid=${appealUuid}`;
  }
  return appealClient.get<AppealApplicationRecordsResponse>(route);
};

/** to get available exams results to appeal
 * */
export const getAppealAvailableResults = (token: string) =>
  appealClient.get<AppealAvailableLevelResponse>(`${ROUTES.GET_AVAILABLE_RESULTS}?token=${token}`);

/** to get available exam listings for a particular exam level
 * */
export const getAppealExamListing = (series: string, year: string, code: string, token: string) =>
  appealClient.get<AppealListingResponse>(
    `${ROUTES.GET_APPEAL_LISTING}/${series}/${year}/${code}?token=${token}`
  );

/** to get appeal receipt
 * */
export const getAppealReceipt = (internalTransactionRef: string) =>
  appealClient.get<AppealTransactionDetailsInSummary>(
    `${ROUTES.GET_APPEAL_RECEIPT}/${internalTransactionRef}`
  );

/** to get appeal receipt
 * */
export const postAppealDraft = (csrfToken: string, payload: AppealDraftRequestBody) =>
  appealClient.post<AppealDraftResponseBody>(csrfToken, ROUTES.POST_APPEAL_DRAFT, payload);

/** to get appeal receipt summary
 * */
export const getReviewDraft = (applicationId: string) =>
  appealClient.get<AppealSummaryResponse>(`/${applicationId}${ROUTES.GET_APPEAL_DRAFT_REVIEW}`);
/** to get appeal receipt summary
 * */
export const getResitReceiptSummary = (uuid: string) =>
  appealClient.get<AppealSummaryResponse>(`${ROUTES.GET_APPEAL_RECEIPT_SUMMARY}/${uuid}`);

/** get candidate appeal download summary s3 pre-signed url */
export const getCandidateDownloadSummary = (uuid: string) =>
  appealClient.get<ResitDownloadSummary>(
    `${ROUTES.GET_APPEAL_CANDIDATE_DOWNLOAD_SUMMARY}/${uuid}`,
    {
      timeout: 10000,
    }
  );

/** to proceed to payment
 * */
export const postCandidateRegistration = (
  csrfToken: string,
  payload: AppealProceedToPaymentRequestBody
) =>
  appealClient.post<AppealProceedToPaymentResponseBody>(
    csrfToken,
    ROUTES.POST_APPEAL_TO_PAYMENT,
    payload,
    {
      timeout: 30000,
    }
  );

export const postAppealEligibility = (csrfToken: string, payload: ExamLevelCodeRequest) =>
  appealClient.post<EligibilityResponse>(csrfToken, ROUTES.POST_CHECK_ELIGIBILITY, payload);
